module.exports = new __parcel__URL__("fire_storm_tracker_cosmetic.bf02b7d2.png").toString();